import {useEffect, useState} from 'react'
import CustomBox from '../../components/common/CustomBox'
import {useParams, useNavigate} from 'react-router-dom'
import {StyledTypography, StyledBox, Subtitle} from '../AdminPanelStyling'
import PopupComponent from '../ProjectDetails/PopupComponent/PopupComponent'
import SnackbarMessage from '../common/Snackbar/SnackbarMessages.json'
import {useCreateClient} from '../api/createClient'
import {useCreateProjectDetails} from '../api/createProject'
import {useGetClientName} from '../api/getClientName'
import {useUpdateClientName} from '../api/updateClientName'
import GreenBarLine from '../common/GreenBarLine'
import {SaveButton, CancelButton} from '../ProjectDetails/ProjectDetailStyle'
import UserManagementComponent from '../UserManagement/UserManagementComponent'
import BreadcrumbsComponent from '../common/BreadcrumbsRoute/BreadcrumbComponent'
import SectionDividerLineComponent from '../common/SectionDividerLine/SectionDividerLineComponent'
import SnackbarComponent from '../common/Snackbar/SnackbarComponent'
import RequirementBox from '../common/RequirementBox'
import LoadingIcon from '../common/LoadingIcon/LoadingIcon'
import {handleInput} from '../common/Helpers/validator'
import {
  InputError,
  NameTitleNormal,
  DescriptionTitle,
  TryButton,
  EditClientButton,
  StyledDiv,
  TitleEdit,
  MainBoxClientLanding
} from './CreateClientStyles'
import InlineErrors from '../../AdminPanel/common/Errors/InlineErrors.json'
import {useGetClientDetails} from '../api/getClientDetails'
import {
  clientNameChanged,
  emailChanged,
  firstNameChanged,
  lastNameChanged
} from './../ProjectDetails/Helper/CompareChanges'
import loadingTitles from '../../appConfig/loadingTitles.config.json'
import buttonTitles from '../../appConfig/buttonTitles.config.json'
import PropTypes from 'prop-types'
import {useAddDeliveryAdmin} from '../api/addDeliveryAdmin'
import {TextField} from '@mui/material'
import CreateIcon from '@mui/icons-material/Create'

const CreateClientComponent = ({setIsAdminPanelOpen}) => {
  const [errorMsg, setErrorMsg] = useState('')
  const [usData, setUsData] = useState('') // sonar-setClData
  const [clientName, setClientName] = useState('')
  const [currentClientName, setCurrentClientName] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [goBack, setGoBack] = useState(false)
  const [emailAddress, setEmailAddress] = useState('')
  const [errorInput, setErrorInput] = useState(false)
  const [popupStyle, setPopupStyle] = useState('')
  const [errorTextEnabled, setErrorTextEnabled] = useState(false)
  const [inputDisabled, setInputDisabled] = useState(false)
  const [showNotification, setShowNotification] = useState(false)
  const [errorText, setErrorText] = useState('')
  const [open, setOpen] = useState(false)
  const [isClientNameFocused, setIsClientNameFocused] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('')
  const [addClient, {data, loading: loadingClient, error: errorClient}] = useCreateClient() // sonar - data: data
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true)
  const [reset, setReset] = useState(false)
  const [projectId, setProjectId] = useState('')
  const [creategroup, {loading: loadingGroup, error: errorGroup}] = useCreateProjectDetails()
  const [createUser, {data: userData, loading: loadingUser, error: errorUser}] = useAddDeliveryAdmin()
  const [updateClient, {loading: loadingUpdateClient, error: errorUpdateClient}] = useUpdateClientName()
  const {clientId} = useParams()
  const isCreateMode = !clientId
  const {clientNameData, loadingClientName, errorClientName} = useGetClientName(clientId)
  const {clientData, loadingClients, error: errorClientDetails, refetch} = useGetClientDetails()
  const [clientList, setClientList] = useState([])
  const [navigateCheck, setNavigateCheck] = useState(false)
  const [clientTitle, setClientTitle] = useState('Create new client')
  const loading =
    loadingClient || loadingGroup || loadingUser || loadingClientName || loadingUpdateClient || loadingClients
  const errorInFetching =
    errorClient || errorGroup || errorInput || errorUser || errorClientDetails || errorUpdateClient
  const [clientWarning, setClientWarning] = useState(false)
  const [addAdminError, setAddAdminError] = useState(false)
  const [showPopupOnNav, setShowPopupOnNav] = useState(false)

  const enableInput = () => {
    setInputDisabled(true)
    setClientWarning(true)
  }
  const navigationProps = [
    {
      key: 'client',
      name: 'Create new client'
    }
  ]
  useEffect(() => {
    if (!loadingClientName) {
      if (clientNameData?.clientDetails?.CLIENT_NAME) {
        setClientName(clientNameData.clientDetails.CLIENT_NAME)
        setCurrentClientName(clientNameData.clientDetails.CLIENT_NAME)
        setClientTitle(clientNameData.clientDetails.CLIENT_NAME)
        if (clientNameData.clientDetails.GROUP_ID) {
          setProjectId(clientNameData.clientDetails.GROUP_ID)
        }
      }
    }
  }, [clientNameData, loadingClientName])

  useEffect(() => {
    if (!errorInFetching && !loading && !showNotification && navigateCheck) {
      if ((isCreateMode && creategroup && createUser) || (handleUpdateClient && !handleAddAdmin && !errorClientName)) {
        navigate(`/adminpanel/`)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreateMode, createUser, creategroup, showNotification])

  useEffect(() => {
    if (usData && errorUser) {
      navigate(`/adminpanel/client/${usData.data.createClient.createClient.clientId}/details`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorUser])

  useEffect(() => {
    if (!isCreateMode && clientName === '') {
      if (isClientNameFocused) {
        setErrorTextEnabled(false)
      } else {
        setErrorTextEnabled(true)
        setErrorText(InlineErrors.nameEmptyError)
      }
    }
  }, [clientName, isClientNameFocused, isCreateMode])
  useEffect(() => {
    setIsAdminPanelOpen(true)
  })

  useEffect(() => {
    setShowNotification(false)

    if (data) {
      setClientName('')
      setSnackbarMessage(SnackbarMessage.clientAdded)
    } else if (!loading) {
      let errorMsg
      if (errorClient) {
        errorMsg = SnackbarMessage.createClientError
      } else if (errorGroup) {
        errorMsg = SnackbarMessage.createGroupError
      } else if (errorUpdateClient) {
        errorMsg = SnackbarMessage.updateClientError
      } else if (errorUser && addAdminError) {
        errorMsg = SnackbarMessage.adminAddError
      } else if (errorUser) {
        errorMsg = SnackbarMessage.createUserError
      }
      if (errorMsg) {
        setErrorMsg(errorMsg)
        setShowNotification(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, errorClient, errorGroup, errorUser, addAdminError, errorUpdateClient])

  const setInputValue = (firstName, lastName, email, errorInput, resetValue) => {
    setFirstName(firstName)
    setLastName(lastName)
    setEmailAddress(email)
    setErrorInput(errorInput)
    setReset(resetValue)
  }

  const checkClientUpdate = (setShowPopupOnNav, clientChanges) => {
    const {clientName, currentClientName, firstName, lastName, emailAddress} = clientChanges
    currentClientName !== clientName ||
    firstNameChanged(firstName) ||
    lastNameChanged(lastName) ||
    emailChanged(emailAddress)
      ? setShowPopupOnNav(true)
      : setShowPopupOnNav(false)
  }

  useEffect(() => {
    if (
      clientNameChanged(clientName, currentClientName, clientList) ||
      firstNameChanged(firstName) ||
      lastNameChanged(lastName) ||
      emailChanged(emailAddress)
    ) {
      setSaveButtonDisabled(false)
    } else {
      setSaveButtonDisabled(true)
    }
    if (isCreateMode) {
      if (clientName.length === 0) {
        setSaveButtonDisabled(true)
      } else {
        setSaveButtonDisabled(false)
      }
    }
    const clientChanges = {
      clientName,
      currentClientName,
      firstName,
      lastName,
      emailAddress
    }
    checkClientUpdate(setShowPopupOnNav, clientChanges)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstName, lastName, emailAddress, clientName])

  const createNewGroup = async (data) => {
    const groupCreated = await creategroup({
      variables: {
        clientId: data.data.createClient.createClient.clientId.toString(),
        groupName: 'Delivery Admin Group',
        groupType: '2'
      }
    })
    return groupCreated
  }

  const saveClient = async () => {
    setPopupStyle('save and exit')
    if (clientName && handleInput) {
      const usData1 = await addClient({variables: {clientName}})
      setUsData(usData1) // sonar
      if (!loadingClient && usData1) {
        const cg = await createNewGroup(usData1)
        if (!loadingGroup && cg) {
          setAddAdminError(false)
          const cu = await createUser({
            variables: {
              groupId: cg.data.creategroup.userGroup.group_id.toString(),
              email: emailAddress.trim(),
              firstName: firstName.trim(),
              lastName: lastName.trim()
            }
          })
          if (!errorInput && !errorInFetching && cu) {
            setShowNotification(true)
            setSnackbarMessage(SnackbarMessage.clientAdded)
            setNavigateCheck(true)
          }
        }
      }
    }
  }

  useEffect(() => {
    if (clientData) {
      const clientList1 = clientData.clientList.map((element) => element.CLIENT_NAME)
      setClientList(clientList1)
    }
  }, [clientData])

  const saveButtonDisableConditions = () => {
    if (clientId) {
      return !inputDisabled || saveButtonDisabled || clientName === currentClientName || errorTextEnabled
    }
    return (
      showNotification ||
      saveButtonDisabled ||
      errorTextEnabled ||
      loadingClient ||
      errorInput ||
      !firstName ||
      !lastName ||
      !emailAddress
    )
  }

  const addButtonDisableConditions = () => {
    return errorTextEnabled || !firstName || !lastName || !emailAddress || errorInput
  }

  const navigate = useNavigate()

  const handleClickOpen = () => {
    setOpen(true)
  }

  const cancelClient = () => {
    if (showPopupOnNav) {
      setPopupStyle('cancel')
      handleClickOpen()
    } else {
      navigate(`/adminpanel`)
    }
  }

  const resetAll = () => {
    setErrorTextEnabled(false)
    if (isCreateMode || createUser || creategroup) {
      setClientName('')
      setReset(true)
    }
  }

  const handleRetry = async () => {
    const group = await createNewGroup(usData)
    if (group) {
      setShowNotification(true)
    }
  }

  const handleAddAdmin = async () => {
    setAddAdminError(true)
    const cu = await createUser({
      variables: {
        groupId: projectId,
        email: emailAddress,
        firstName,
        lastName
      }
    })
    if (!errorInFetching && !errorUser && cu) {
      setShowNotification(true)
      setSnackbarMessage(SnackbarMessage.addUserSuccess)
      setNavigateCheck(false)
    }
  }

  const handleError = Array.isArray(errorMsg) ? errorMsg[0] : errorMsg

  const handleUpdateClient = async (exit) => {
    exit ? setPopupStyle('save and exit') : setPopupStyle('save')
    const uc = await updateClient({
      variables: {
        clientId: Number.parseInt(clientId),
        clientName
      }
    })
    if (!errorInFetching && !errorClientName && !errorUpdateClient && uc) {
      setCurrentClientName(clientName)
      setClientTitle(clientName)
      setInputDisabled(false)
      setShowNotification(true)
      setSnackbarMessage(SnackbarMessage.userEditSuccess)
      setNavigateCheck(false)
      refetch()
    }
    if (exit) {
      setNavigateCheck(true)
    }
  }

  return (
    <div>
      <MainBoxClientLanding component='main'>
        {loading ? (
          <LoadingIcon title={loadingTitles.clientDetails} data-testid='loading icon' />
        ) : (
          <StyledBox>
            {navigationProps && (
              <div>
                <BreadcrumbsComponent
                  props={
                    clientId
                      ? [
                          {
                            key: 'client',
                            name: currentClientName
                          }
                        ]
                      : navigationProps
                  }
                  setPopupStyle={setPopupStyle}
                  showPopup={showPopupOnNav}
                  goBack={goBack}
                  setOpen={setOpen}
                  isClient={true}
                />
                <StyledTypography variant='h5' title={clientTitle} tabIndex={0}>
                  {clientTitle}
                </StyledTypography>
                <GreenBarLine title='greenBarLineClient' />
                <StyledDiv>
                  <DescriptionTitle>Client Details</DescriptionTitle>
                  {clientId && (
                    <EditClientButton
                      title={buttonTitles.editClientName}
                      onClick={enableInput}
                      data-testid='edit client button'
                    >
                      <CreateIcon variant='primaryIcon' />
                    </EditClientButton>
                  )}
                </StyledDiv>
                <NameTitleNormal>Client Name</NameTitleNormal>
              </div>
            )}
            <div>
              {!inputDisabled && clientId && <TitleEdit>{clientName}</TitleEdit>}
              {(!clientId || inputDisabled) && (
                <TextField
                  size='small'
                  margin='dense'
                  id='enter-client-name'
                  aria-label='enter-client-name'
                  inputProps={{'aria-labelledby': 'enter-client-name'}}
                  errorTextEnabled={errorTextEnabled}
                  disabled={clientId && !inputDisabled}
                  value={clientName}
                  error={errorTextEnabled}
                  placeholder='Enter client name'
                  onChange={handleInput(
                    setClientName,
                    setErrorTextEnabled,
                    setErrorText,
                    false,
                    clientList,
                    currentClientName
                  )}
                  onFocus={() => setIsClientNameFocused(true)}
                  onBlur={() => setIsClientNameFocused(false)}
                  sx={{marginLeft: '4px'}}
                />
              )}
            </div>
            <CustomBox tabIndex={0} hidden={!errorTextEnabled}>
              <InputError id='client-name-error' aria-live='polite'>
                {errorTextEnabled && errorText}
              </InputError>
            </CustomBox>
            {!clientId || inputDisabled ? <RequirementBox props={'Client'} /> : ''}
            <SectionDividerLineComponent />
            <StyledTypography variant='h5' tabIndex={0}>
              Who will have access to this client?
            </StyledTypography>
            <Subtitle variant='subtitle1' tabIndex={0}>
              This should be the Delivery Team Admin&apos;s working with this client. They will have the ability to
              create new projects and adjust permissions.
            </Subtitle>
            <br />
            <StyledTypography variant='h5' sx={{marginBottom: '8px'}}>
              Add Delivery Team Admin
            </StyledTypography>
            <UserManagementComponent
              clientProjectId={projectId}
              handleAddAdmin={handleAddAdmin}
              addButtonDisableConditions={addButtonDisableConditions}
              isCompleted={true}
              setInputValue={setInputValue}
              isClientComponent={true}
              clientUserData={userData || reset}
            />
            <div>
              <SectionDividerLineComponent />
              <SaveButton
                onClick={() => (clientId ? handleUpdateClient(true) : saveClient())}
                disabled={saveButtonDisableConditions()}
              >
                Save And Exit
              </SaveButton>
              {clientId && (
                <SaveButton
                  onClick={() => (clientId ? handleUpdateClient(false) : saveClient())}
                  disabled={saveButtonDisableConditions()}
                >
                  Save
                </SaveButton>
              )}
              <CancelButton variant='contrastButton' onClick={cancelClient}>
                Cancel
              </CancelButton>
            </div>
            {open && (
              <PopupComponent
                open={open}
                setOpen={setOpen}
                popupStyle={popupStyle}
                resetAll={resetAll}
                setGoBack={setGoBack}
                clientWarning={clientWarning}
                toggleWarn={true}
              />
            )}
            <SnackbarComponent
              error={errorInFetching}
              showNotification={showNotification}
              setShowNotification={setShowNotification}
              message={errorInFetching ? handleError : snackbarMessage}
              isClient={'true'}
              tryAgain={
                Array.isArray(errorMsg) && (
                  <TryButton color='error' fontSize='inherit' onClick={handleRetry}>
                    {errorMsg[1]}
                  </TryButton>
                )
              }
            />
          </StyledBox>
        )}
      </MainBoxClientLanding>
    </div>
  )
}

CreateClientComponent.propTypes = {
  setIsAdminPanelOpen: PropTypes.func
}

export default CreateClientComponent

/* Function Descriptions:
  - enableInput: Enables input fields and displays a client warning.
  - checkClientUpdate: Checks if client details have been updated and sets a popup state accordingly.
  - createNewGroup: Creates a new group for the client with specified details.
  - saveClient: Saves a new client and creates associated group and admin user.
  - saveButtonDisableConditions: Determines if the save button should be disabled based on various conditions.
  - addButtonDisableConditions: Determines if the add admin button should be disabled based on input validation.
  - handleClickOpen: Opens the popup dialog.
  - cancelClient: Cancels the client creation or update process and navigates back if no unsaved changes exist.
  - resetAll: Resets all input fields and states related to client creation.
  - handleRetry: Retries the group creation process in case of failure.
  - handleAddAdmin: Adds a delivery admin to the client group.
  - handleUpdateClient: Updates the client details and optionally navigates back.
  - setInputValue: Sets the input values for first name, last name, and email address.
  - handleError: Retrieves the error message to display in the snackbar.
  - createClientComponent: Renders the create client component.
  - useEffect: Manages side effects related to fetching client data, updating state, and handling errors.
  - getClientDetails: Fetches client details and sets the client list.
*/
